import { ApolloClient } from 'apollo-client'
// import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import config from '../config'

// export const client = new ApolloClient({
//   link: createHttpLink({ uri: 'http://192.168.22.29:8080/v1alpha1/graphql' }),
//   cache: new InMemoryCache()
// })

import { split } from 'apollo-link'
import { HttpLink } from 'apollo-link-http'
import { WebSocketLink } from 'apollo-link-ws'
import { getMainDefinition } from 'apollo-utilities'

// Create an http link:
const httpLink = new HttpLink({
  uri: config.omega_graphql_api
})

// Create a WebSocket link:
const wsLink = new WebSocketLink({
  uri: config.omega_graphql_ws,
  options: {
    reconnect: true
  }
})

// using the ability to split links, you can send data to each link
// depending on what kind of operation is being sent
const link = split(
  // split based on operation type
  ({ query }) => {
    const definition = getMainDefinition(query)
    return (
      definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
    )
  },
  wsLink,
  httpLink
)
export const client = new ApolloClient({
  link,
  cache: new InMemoryCache()
})
